'use client';

import { c as _c } from "react/compiler-runtime";
import { Accordion } from '@7f-ui/components/accordion/accordion';
import { Price } from '@7f-ui/components/price';
import { shopTestId } from '@utils/utils-shop-test-ids';
import { useExperienceFilterContext } from 'src/app/erlebnisse/_components/app-experience-filter-provider';
import { useAppExperienceAvailableDates } from 'src/app/erlebnisse/_hooks/use-app-experience-available-dates';
import { useExperienceOptions, type VariantOption } from 'src/app/erlebnisse/_hooks/use-app-experience-options';
import { useExperiencePriceCategoryName } from 'src/app/erlebnisse/_hooks/use-app-experience-price-category-name';
import { useAppExperienceTimeslotsPreview } from 'src/app/erlebnisse/_hooks/use-app-experience-timeslots-preview';
export function AppExperiencePrices() {
  const $ = _c(10);
  const {
    filter,
    experience
  } = useExperienceFilterContext();
  const {
    allOptions,
    getVariantOptions
  } = useExperienceOptions(experience.variants);
  const hasTimeslotOffers = experience.experienceType !== "ticket";
  const {
    availableDates,
    isLoading
  } = useAppExperienceAvailableDates(experience.publicId, filter.selectedVariant, filter.selectedOptions, hasTimeslotOffers);
  const {
    isLoading: isPreviewLoading
  } = useAppExperienceTimeslotsPreview(hasTimeslotOffers);
  const hasTimeslots = !!availableDates?.length;
  const hasMultipleVariants = experience.variants.length > 1;
  if (isLoading || isPreviewLoading || hasTimeslots || allOptions.length < 2) {
    return null;
  }
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = shopTestId("ExperiencePrices.root");
    t1 = <h2 className="mb-4 font-heading2">Preise</h2>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== allOptions || $[3] !== experience.variants || $[4] !== filter.selectedVariant || $[5] !== getVariantOptions || $[6] !== hasMultipleVariants) {
    t2 = hasMultipleVariants ? experience.variants.map(variant => <div key={variant.id} data-testid={shopTestId("ExperiencePrices.variant")}><Accordion title={variant.title} titleVariant="heading" titleAs="h3" color="ghost" expanded={variant.id === filter.selectedVariant}><ExperiencePriceOptions options={getVariantOptions(variant.id)} headingAs="h4" /></Accordion></div>) : <ExperiencePriceOptions options={allOptions} />;
    $[2] = allOptions;
    $[3] = experience.variants;
    $[4] = filter.selectedVariant;
    $[5] = getVariantOptions;
    $[6] = hasMultipleVariants;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t2) {
    t3 = <section className="hidden border-b-0 bg-sand py-8 sm:mx-0 sm:block sm:rounded-3xl sm:px-6" data-experience-prices={true} data-testid={t0}>{t1}{t2}</section>;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}
function ExperiencePriceOptions(t0) {
  const $ = _c(16);
  const {
    options,
    headingAs: t1
  } = t0;
  const Heading = t1 === undefined ? "h3" : t1;
  const {
    experience
  } = useExperienceFilterContext();
  const getExperiencePriceCategoryName = useExperiencePriceCategoryName();
  const t2 = experience.priceCategory === "Ticket" ? "ticket" : "persons";
  let t3;
  if ($[0] !== getExperiencePriceCategoryName || $[1] !== t2) {
    t3 = getExperiencePriceCategoryName(t2);
    $[0] = getExperiencePriceCategoryName;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const singleUnitCategory = t3;
  let t4;
  if ($[3] !== Heading || $[4] !== experience.currency || $[5] !== getExperiencePriceCategoryName || $[6] !== options || $[7] !== singleUnitCategory) {
    let t5;
    if ($[9] !== Heading || $[10] !== experience.currency || $[11] !== getExperiencePriceCategoryName || $[12] !== singleUnitCategory) {
      t5 = option => {
        const categoryName = getExperiencePriceCategoryName(option.name);
        const description = option.description?.trim() ?? "";
        const hasOwnDescription = !!description && description.toLowerCase() !== categoryName.toLowerCase();
        return <li key={`${option.variantId}-${option.id}`} className="flex flex-col" data-testid={shopTestId("ExperiencePrices.option")}>{hasOwnDescription && <Heading className="font-heading5">{categoryName}</Heading>}<div className="flex items-baseline gap-4 font-body-small">{hasOwnDescription ? <p className="max-w-96 flex-1">{description}</p> : <Heading className="max-w-96 flex-1 font-heading5">{categoryName}</Heading>}<p className="ml-auto whitespace-nowrap"><Price amount={option.price} currency={experience.currency} />{" / "}{option.groupSize === 1 ? singleUnitCategory : categoryName}</p></div>{option.groupSize > 1 && <p className="font-body-small">{`für ${option.groupSize} Personen`}</p>}</li>;
      };
      $[9] = Heading;
      $[10] = experience.currency;
      $[11] = getExperiencePriceCategoryName;
      $[12] = singleUnitCategory;
      $[13] = t5;
    } else {
      t5 = $[13];
    }
    t4 = options.map(t5);
    $[3] = Heading;
    $[4] = experience.currency;
    $[5] = getExperiencePriceCategoryName;
    $[6] = options;
    $[7] = singleUnitCategory;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[14] !== t4) {
    t5 = <ul className="flex flex-col gap-4">{t4}</ul>;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}